module.exports = __webpack_public_path__ + "static/hero-7772e942dc8081d7dde5dced86855acc.png";